/**
 * Constantes del export de eventos.
 *
 * El tope de rango es el mismo que el de los reportes de auditoría y vive una
 * sola vez en `report-date-range`. Acá quedan los nombres con los que ya lo
 * consume `Dashboard`, más lo propio del export de eventos (el criterio de
 * orden).
 */
import {
  REPORT_MAX_RANGE_MONTHS,
  addCalendarMonths as addCalendarMonthsShared,
  getMaxReportDateTo,
  getMinReportDateFrom,
  isReportDateRangeWithinLimit,
} from "./report-date-range";

/** Maximum inclusive calendar span for event report export (dateFrom → dateTo). */
export const EVENT_REPORT_MAX_RANGE_MONTHS = REPORT_MAX_RANGE_MONTHS;

export const EVENT_REPORT_DATE_RANGE_HINT = `Podés exportar hasta ${EVENT_REPORT_MAX_RANGE_MONTHS} meses por consulta.`;

export const eventReportDateRangeExceededMessage = () =>
  `El rango de fechas no puede superar ${EVENT_REPORT_MAX_RANGE_MONTHS} meses`;

export const addCalendarMonths = addCalendarMonthsShared;

export const isEventReportDateRangeWithinLimit = isReportDateRangeWithinLimit;

export const getMaxEventReportDateTo = getMaxReportDateTo;

export const getMinEventReportDateFrom = getMinReportDateFrom;

/** Criterio de orden del export. Debe coincidir con `sortBy` del endpoint. */
export type EventReportSortField = "start_date" | "create_date";

export const EVENT_REPORT_SORT_FIELD_OPTIONS: {
  label: string;
  value: EventReportSortField;
}[] = [
  { label: "Fecha de realización", value: "start_date" },
  { label: "Fecha de creación", value: "create_date" },
];

export const DEFAULT_EVENT_REPORT_SORT_FIELD: EventReportSortField = "start_date";
